import { Format } from "../../../utils/types/generals"
import { DepartmentWithoutConfig } from "../responses"

export const formatDepartmentWithoutConfig = async ({ response }: { response: DepartmentWithoutConfig }): Format<DepartmentWithoutConfig> => {
    return {
        data: response,
        item: response.map(department => ({
            label: department.name,
            value: department.id,
            areaId: department.areaId,
            id: department.id.toString(),
        }))
    }
}